export function isJSON(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
export function parseJson(jsonString) {
    if (jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch (e) {
            return undefined;
        }
    }
    return undefined;
}
//# sourceMappingURL=JSONUtils.js.map